import { UniformStatsSection } from "./src/stats-section.tsx";

export default UniformStatsSection;
